import React from 'react';
import styled from 'styled-components';

import Avatar from '../Avatar';
import { DescriptionText } from '../Typography';
import Space from '../Space';
import theme from '../theme';

type AgentProfileProps = {
  user: {
    firstName?: string;
    lastName?: string;
    name?: string;
    avatarFilestackId?: string;
    org?: {
      name: string;
    };
  };
  showOrgName?: boolean;
  nameTextStrong?: boolean;
};

const AgentProfile: React.FC<AgentProfileProps> = ({
  user,
  showOrgName,
  nameTextStrong,
}) => {
  const avatarUser = {
    firstName: user.firstName || user.name || '',
    lastName: user.lastName || '',
    name: user.name || '',
    avatarFilestackId: user.avatarFilestackId,
  };

  const fullName = user.name || `${user.firstName} ${user.lastName}`;

  return (
    <div>
      <Space>
        <Avatar user={avatarUser} width={18} />
        <DescriptionText strong={nameTextStrong}>{fullName}</DescriptionText>
      </Space>
      {showOrgName && (
        <OrgNameContainer>{user.org?.name || ''}</OrgNameContainer>
      )}
    </div>
  );
};

export default AgentProfile;

const OrgNameContainer = styled.div`
  color: ${theme.gray8};
  padding-left: 24px;
`;
